<template>
    <div class="login">
        <div class="login-content">
            <!-- 左侧的图片 -->
            <div class="content-left">
                <div class="content-left-title">中国地震科学实验场</div>
                <div class="content-left-second-title">现场工作信息管理系统</div>
                <div class="content-left-line"></div>
            </div>
            <!-- 右侧的登录内容 -->
            <div class="content-right">
                <!-- 标题 -->
                <h4>Hello! 欢迎登录 </h4>
                <!-- 身份 -->
                <div class="item">
                    <div class="icon"><img src="../../assets/iconFolder/login/login_icon_identity.png" alt=""></div>
                    <!-- 身份选择 -->
                    <el-select v-model="personObj.identity" placeholder="请选择账户身份">
                        <el-option
                        v-for="item in identityOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <!-- 用户名 -->
                <div class="item">
                    <div class="icon"><img src="../../assets/iconFolder/login/login_icon_account.png" alt=""></div>
                    <!-- 用户名输入框 -->
                    <input v-model="personObj.account" class="max" type="text" placeholder="请输入账号">
                </div>
                <!-- 密码 -->
                <div class="item">
                    <div class="icon"><img src="../../assets/iconFolder/login/login_icon_password.png" alt=""></div>
                    <input v-model="personObj.password" class="password" :type="isShow ? 'text' : 'password'" placeholder="请输入密码" >
                    <img class="passshow" @click="isShow = !isShow" :src="
                        isShow
                            ? require('../../assets/iconFolder/login/login_password_open.png')
                            : require('../../assets/iconFolder/login/login_password_close.png')
                    " alt="" />
                </div>
                <!-- 验证码 -->
                <div class="verify">
                    <div class="item short">
                        <div class="icon">
                            <img src="../../assets/iconFolder/login/login_icon_verify.png" alt="" />
                        </div>
                        <input style="width: 146px" type="text" placeholder="请输如验证码" v-model="personObj.verify" />
                    </div>
                    <div class="code">
                        <img class="login-verify" :src="verifyUrl" alt="#" @click="getLoginVerify" />
                    </div>
                </div>
                <!-- 登录按钮 -->
                <button @click="loginAction" class="login-btn">登  录</button>
                <!-- 说明 -->
                <div class="technical-support">技术支持：第四纪数字地球（北京）科技有限公司</div>
            </div>
        </div>
    </div>
</template>
<script>

import { GetLoginVerify, Login } from '@/http/api/api-hb'
export default {
    data() {
        return {
            // 用户身份选择
            identityOptions: [
                {
                    value: 0,
                    label: '中国地震局地球物理研究所'
                },
                // {
                //     value: 1,
                //     label: '云南省地震局'
                // },
                {
                    value: 1,
                    label: '省地震局'
                },
                {
                    value: 2,
                    label: '施工单位'
                }
            ],
            // 密码是否显示
            isShow: false,
            verifyUrl: null,
            // 用户
            personObj: {
                // identity: 0,
                // account:  '18610525280', // '15299999999', //'15299999999', // '18610525280', // 18610525288
                // password: '123456', //'p4O46O', 
                // identity: 2,
                // account:  '15076283261', // '15299999999', //'15299999999', // '18610525280', // 18610525288
                // password: '9A3s2C', //'p4O46O',
                identity: null,
                account:  null,
                password: null,
                verify: null,
                verifyUuid: null
            }
        }
    },
    mounted() {
        this.getLoginVerify()
    },
    methods: {
        // 获取验证码
        getLoginVerify() {
            GetLoginVerify().then(res => {
                if (res.code === 200) {
                    this.verifyUrl = 'data:image/png;base64,' + res.img
                    this.personObj.verifyUuid = res.uuid;
                } else {
                    this.$message({ type: "warning", message: res.msg });
                }
            })
        },
        // 登录
        loginAction() {
            const params = {
                mobile: this.personObj.account,
                password: this.personObj.password,
                role: this.personObj.identity,
                uuid: this.personObj.verifyUuid,
                code: this.personObj.verify,
            };
            Login(params).then(res => {
                if (res.code === 200) {
                    localStorage.setItem("user", JSON.stringify(res.data));
                    localStorage.setItem("token", res.data.token);
                    this.$router.push({ name: "workModule" });
                } else {
                    this.getLoginVerify();
                    this.$message({ type: 'warning', message: res.msg })
                }
            })
        }
    },
}
</script>
<style scoped>
    .login {
        width: 100%;
        height: 100%;
        background-image: url("../../assets/iconFolder/login/login_bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
    }
    .login .login-content {
        width: 1192px;
        height: 728px;
        display: flex;
        margin: auto;
    }
    .login .login-content .content-left {
        width: 50%;
        height: 100%;
        /* background-color: aquamarine; */
        /* background: linear-gradient(180deg, #359FFF 0%, #0065C1 100%); */
        border-radius: 6px 0px 0px 6px;
        background-image: url("../../assets/iconFolder/login/login_left_bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }
    .content-left-title {
        font-size: 44px;
        line-height: 50px;
        margin: 82px 0 16px 52px;
    }
    .content-left-second-title {
        font-size: 32px;
        line-height: 45px;
        margin-left: 52px;
    }
    .content-left-line {
        margin: 22px 0 0 52px;
        width: 61px;
        height: 4px;
        background: #FFFFFF;
        opacity: 0.42;
    }
    .login .login-content .content-right {
        width: calc(50% - 240px);
        height: 100%;
        padding: 0 120px;
        background-color: #fff;
        border-radius: 0px 6px 6px 0px;
        position: relative;
    }
    /* 标题 */
    .content-right h4 {
        width: 100%;
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 40px;
        margin: 95px 0 52px 0;
    }
    /* 每一项 */
    .content-right .item {
        width: 100%;
        height: 52px;
        border-radius: 27px;
        overflow: hidden;
        margin-bottom: 16px;
        background-color: #F3F7FF;
        display: flex;
        align-items: center;
    }
    .content-right .item.short {
        margin: 0;
        width: calc(100% - 140px);
    }
    .content-right .item .icon {
        width: 78px;
        height: 52px;
        background: #0054A0;
        border-radius: 27px;
    }
    .content-right .item .icon img {
        width: 26px;
        height: 26px;
        margin: 13px 26px;
    }
    /* 选择框 */
    .content-right .item /deep/ .el-select {
        width: calc(100% - 78px);
        height: 52px;
        background: none;
    }
    .content-right .item /deep/ .el-select .el-input__inner {
        height: 52px;
        border: none;
        background: none;
        padding-right: 52px;
        font-size: 16px;
        color: #000;
    }   
    .content-right .item /deep/ .el-select .el-input .el-select__caret.el-input__icon {
        width: 40px !important;
        font-size: 20px;
    }
    /* 输入框 */
    .content-right .item input.max {
        width: calc(100% - 78px);
    }
    .content-right .item input.password {
        width: calc(100% - 122px);
    }
    .content-right .item input {
        height: 52px;
        padding-left: 16px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
        background: none;
        border: none;
        box-shadow: none;
    }
    .content-right .item input:focus {
        outline: none;
    }
    .item .passshow {
        width: 20px;
        height: 20px;
        margin: 12px 16px 12px 8px;
    }
    /* 验证码 */
    .verify {
        width: 100%;
        height: 52px;
        display: flex;
        /* justify-content: space-between; */
        align-items: center;
    }
    .verify .code {
        width: 132px;
        height: 52px;
        border-radius: 27px;
        background: linear-gradient(218deg, #32C5FF 0%, #B620E0 51%, #F7B500 100%);
        margin-left: 8px;
        overflow: hidden;
    }
    /* 按钮 */
    .content-right .login-btn {
        width: 100%;
        height: 52px;
        background: #0054A0;
        border-radius: 27px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 30px;
        margin-top: 52px;
    }
    /* 技术支持 */
    .content-right .technical-support {
        width: calc(100% - 240px);
        position: absolute;
        bottom: 24px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
        opacity: 0.3;
    }
</style>